<template>
  <Validator></Validator>
</template>
<script>
import Validator from  '../components/validator.vue';
export default {
  components: {
    Validator
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/page/project-system/personal/index.vue